<template>
  <div>
    <el-button type="success" style="margin-bottom: 20px" @click="showPost">生成海报</el-button>
    <div class="content">
      <!-- 海报html元素 -->
      <div id="posterHtml" class="box_items" :style="{backgroundImage: 'url('+posterHtmlBg+')'}">
        <div class="content_txt">{{ posterContent }}</div>
        <!-- 二维码 -->
        <div class="qrcode">
          <div id="qrcodeImg"></div>
        </div>
      </div>

      <div class="info_tab" v-if="showTimes">
        <img :src="posterImg">
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'

export default {
  name: "Test",
  data() {
    return {
      posterContent: '海报图', // 文案内容
      posterHtmlBg: require('../../assets/images/pinsx.png'), // 背景图
      posterImg: '', // 最终生成的海报图片
      showTimes: false
    }
  },
  mounted() {
    this.createQrcode('https://www.baidu.com/')
  },
  methods: {
    showPost() {
      this.createPoster()
      setTimeout(() => {
        this.showTimes = true
      }, 500)
    },
    createQrcode(text) {
      // 生成二维码
      const qrcodeImgEl = document.getElementById('qrcodeImg')
      qrcodeImgEl.innerHTML = ''
      let qrcode = new QRCode(qrcodeImgEl, {
        width: 120,
        height: 120,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode.makeCode(text)
    },
    createPoster() {
      // 生成海报
      const vm = this
      const domObj = document.getElementById('posterHtml')
      html2canvas(domObj, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector('#posterHtml')
          e.style.display = 'block'
        }
      }).then(function (canvas) {
        // 在微信里,可长按保存或转发
        vm.posterImg = canvas.toDataURL('image/png')
      })
    },
  }
}
</script>

<style scoped lang="scss">
.content {
  display: flex;
}

.box_items {
  width: 436px;
  border-radius: 40px;
  overflow: hidden;
  height: 646px;
  background-size: contain;
  position: relative;

  .qrcode {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }

  .content_txt {
    position: absolute;
    left: 20px;
    bottom: 40px;
    font-size: 18px;
    color: #000000;
  }
}

.info_tab {
  border-radius: 40px;
  overflow: hidden;
  margin-left: 40px;

  img {
    border-radius: 40px;
    overflow: hidden;
  }
}
</style>